import requests from "./httpService";

const SubscriptionServices = {

    getState: async () => {
        return requests.get(`/newlocation/states`);
    },
    getCities: async (id) => {
        return requests.get(`/newlocation/cities/${id}`);
    },

    getSubcriptionUsers: async (type = "online") => {
        return requests.get(`/buymembershipoffer/all-active-subcription-custombar?type=${type}`);
    },

   getSubcriptionAllUsers: async (type = "online") => {
    return requests.get(
        `/buymembershipoffer/all-subcription-customber?type=${type}`
    );
},

    expireSubcriptionAllUsers: async (type = "online") => {
        return requests.get(`/buymembershipoffer/all-expired-subcription-custombar?type=${type}`);
    },


    pandingSubcriptionAllUsers: async (type = "online") => {
        return requests.get(`/buymembershipoffer/pending-subcription-customer?type=${type}`);
    },

  
    userMembershipUpdateStatus: async (id, body) => {
        return requests.patch(`/buymembershipoffer/update-status/${id}`, body);
    },

    updateUserblockStatus: async (id, body) => {
        return requests.patch(`/user/updateBlockStatus/${id}`, body);
    },


}

export default SubscriptionServices;